import { useEffect } from "react";

import { normalizeStandalonePwaTitle } from "~/utils/pwa-title";

function isStandalonePwa() {
    return (
        window.matchMedia("(display-mode: standalone)").matches ||
        ("standalone" in window.navigator &&
            (window.navigator as Record<string, unknown>).standalone === true)
    );
}

function normalizeDocumentTitle() {
    const nextTitle = normalizeStandalonePwaTitle(document.title);
    if (nextTitle && nextTitle !== document.title) {
        document.title = nextTitle;
    }
}

export function PwaTitleNormalizer() {
    useEffect(() => {
        if (!isStandalonePwa()) return;

        normalizeDocumentTitle();

        // AIDEV-NOTE: Desktop PWAs prepend the app name, so strip route titles after navigation.
        const observer = new MutationObserver(normalizeDocumentTitle);
        observer.observe(document.head, {
            childList: true,
            subtree: true,
            characterData: true,
        });

        return () => observer.disconnect();
    }, []);

    return null;
}
